import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/NavBar";
import Home from "./pages/Home/Home";
import Expertise from "./pages/Expertise";
import Certifications from "./pages/Certifications";
import Contact from "./pages/Contact";
import Books from "./pages/Books";
import { AuthProvider } from "./client/AuthProvider";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import { EditModeProvider } from "./context/EditModeContext";
import Timeline from "./pages/Timeline/Timeline";

export default function App() {
  return (
    <AuthProvider>
      <EditModeProvider>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/expertise" element={<Expertise />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/books" element={<Books />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
          </Routes>
        </Router>
      </EditModeProvider>
    </AuthProvider>
  );
}
